import { useState, useCallback } from "react";
import { searcherApi, SearchResponse } from "../services/searcherApi";
import type { Candidate } from "../services/preventiviApi";

export function useSearchCandidates() {
  const [result, setResult] = useState<SearchResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const search = useCallback(async (
    query: string,
    extra?: { topK?: number; disciplina?: "ELE" | "MEC"; sourceFile?: string },
  ) => {
    if (!query.trim()) return;
    setLoading(true);
    setError(null);
    try {
      const res = await searcherApi.search({
        query,
        top_k: extra?.topK ?? 10,
        disciplina: extra?.disciplina,
        source_file: extra?.sourceFile,
        matching_mode: "browse", // Manual search by user
      });
      setResult(res);
    } catch (e: any) {
      setError(e?.response?.data?.detail || "Search error");
    } finally {
      setLoading(false);
    }
  }, []);

  const patchCandidateMetadata = useCallback((uid: string, metadataPatch: Record<string, any>) => {
    setResult((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        candidates: prev.candidates.map((c: Candidate) =>
          c.uid === uid ? { ...c, metadata: { ...c.metadata, ...metadataPatch } } : c
        ),
      };
    });
  }, []);

  const removeCandidate = useCallback((uid: string) => {
    setResult((prev) =>
      prev ? { ...prev, candidates: prev.candidates.filter((c: Candidate) => c.uid !== uid) } : prev
    );
  }, []);

  return { result, loading, error, search, patchCandidateMetadata, removeCandidate };
}
